"use client";

import { useHeaderContext } from "./header.context";
import type { HeaderMobileMenuProps } from "./types/header-mobile-menu.types";
import { headerMobileMenuStyles, headerMobileMenuContentStyles } from "./styles/header-mobile-menu.styles";
import { useEffect, useMemo, useCallback } from "react";

export const HeaderMobileMenu: React.FC<HeaderMobileMenuProps> = (props) => {
  const { children, className, ...rest } = props;

  const { menuOpen, setMenuOpen } = useHeaderContext();

  const inertProps = useMemo(() => {
    return !menuOpen ? { inert: true } : {};
  }, [menuOpen]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    document.body.classList.toggle("overflow-hidden", menuOpen);
  }, [menuOpen]);

  const handleCloseMenu = useCallback(() => {
    setMenuOpen(false);
  }, [setMenuOpen]);

  return (
    <div className={headerMobileMenuStyles({ className, menuOpen })} {...inertProps} {...rest}>
      <div className={headerMobileMenuContentStyles()}>{children}</div>

      <button
        className="fixed left-0 right-0 bottom-0 w-full h-content-height top-header-height z-0 bg-transparent"
        aria-hidden="true"
        onClick={handleCloseMenu}
        tabIndex={-1}
      />
    </div>
  );
};

HeaderMobileMenu.displayName = "HeaderMobileMenu";
